
import type { PropOptions } from 'vue';
import Vue from 'vue';
import { OTHER, skills } from './constants';
import JobsNextButton from '~/components/partials/jobs/JobsNextButton.vue';
import JobsInput from '~/components/partials/jobs/JobsInput.vue';
import JobsStep from '~/components/partials/jobs/JobsStep.vue';
import JobsSelect from '~/components/partials/jobs/JobsSelect/JobsSelect.vue';
import JobsSelectOption from '~/components/partials/jobs/JobsSelect/JobsSelectOption.vue';
import JobsCustomAction from '~/components/partials/jobs/JobsCustomAction/JobsCustomAction.vue';
import { capitalize } from '~/components/utils/core/string';
import type { FormState } from '~/types/common';
import type { Testimonial } from '~/types/graphql';

interface IOption {
  key: string;
  title: string;
  selected: boolean;
  hasIcon: boolean;
}

export default Vue.extend({
  name: 'PublicPortfolioTestifyCompliments',
  components: { JobsCustomAction, JobsStep, JobsInput, JobsNextButton, JobsSelect, JobsSelectOption },
  props: {
    testimonial: {
      type: Object,
      required: true,
    } as PropOptions<Testimonial>,
    formState: {
      type: String,
      required: true,
    } as PropOptions<FormState>,
  },
  data(): { options: Array<IOption> } {
    const selectedSkills = this.testimonial.skills;
    const options = skills.map(skill => ({
      key: skill,
      title: capitalize(skill),
      selected: selectedSkills.includes(skill),
      hasIcon: skill !== OTHER,
    }));
    return {
      options,
    };
  },
  computed: {
    selectedSkills(): Array<IOption> {
      return this.options.filter(option => option.selected);
    },
    isButtonDisabled(): boolean {
      return !this.selectedSkills.length || this.formState === 'submitting';
    },
  },
  methods: {
    handleSave(): void {
      const skills = this.selectedSkills.map(option => option.key);

      this.$emit('next', { skills });
    },
  },
});
